import { render, staticRenderFns } from "./LicitacaoEsclarecimentoImpugnacaoVazio.vue?vue&type=template&id=81880a22&scoped=true"
import script from "./LicitacaoEsclarecimentoImpugnacaoVazio.vue?vue&type=script&lang=js"
export * from "./LicitacaoEsclarecimentoImpugnacaoVazio.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoEsclarecimentoImpugnacaoVazio.vue?vue&type=style&index=0&id=81880a22&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81880a22",
  null
  
)

export default component.exports